"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = exports.enhanceRow = exports.preview2D3DCell = exports.renderCustomMeta = exports.formatMetadata = exports.findOption = exports.getTarget = void 0;
var React = require("react");
var memoize = require("fast-memoize");
var components_1 = require("components");
var moment = require("moment");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var formatSize_1 = require("utils/helpers/formatSize");
var FileIcon_1 = require("components/FileIcon");
var filesMemoize_1 = require("utils/helpers/filesMemoize");
var preview_1 = require("utils/preview");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var RenderFileLink_1 = require("components/RenderFileLink/RenderFileLink");
var getTarget = function (file, isMobile) {
    if (isMobile) {
        switch (file.type) {
            case 'PDF':
                return '_blank';
            case 'PRESENTATION':
            case 'SPREADSHEET':
            case 'TEXT':
                if (/\.(doc|docx|ppt|pps|pptx|xls|xlsx)$/i.test(file.name)) {
                    return '_blank';
                }
        }
    }
    return undefined;
};
exports.getTarget = getTarget;
exports.findOption = memoize(function (meta, value) {
    return meta.options && meta.options.find(function (o) { return o.value === value; });
});
var formatMetadata = function (identifier, value, meta) {
    if (!value || value === '') {
        return '-';
    }
    if (typeof value === 'object') {
        return value.value || value.name || '-';
    }
    else if (meta.type === 'day') {
        return moment(parseInt(value.toString(), 10)).format('l');
    }
    else if (meta.type === 'datetime') {
        return moment(parseInt(value.toString(), 10)).format('l HH:mm');
    }
    else if (identifier === 'size-meta') {
        return (0, formatSize_1.formatSize)(parseInt(value.toString(), 10));
    }
    else if (meta.type === 'checkbox') {
        return value ? (0, translation_1.getLocalization)('global/yes') : '-';
    }
    else if (meta.type === 'select' || meta.type === 'dependant-select') {
        var found = (0, exports.findOption)(meta, value);
        if (found) {
            return found.name;
        }
        return '';
    }
    else {
        return value;
    }
};
exports.formatMetadata = formatMetadata;
exports.renderCustomMeta = memoize(function (cols, file, baseUrl, isMobile, token) {
    var elements = [];
    var columns = cols.columnMap;
    if (!columns) {
        return elements;
    }
    columns.forEach(function (c, key) {
        if (c.id === undefined) {
            return;
        }
        var dataKey = '__' + c.id;
        if (c.identifier === 'name-meta') {
            elements.push(React.createElement(RenderFileLink_1.RenderFileLink, { key: key, file: file, baseUrl: baseUrl, isMobile: isMobile, token: token, dataKey: dataKey, index: key, createLink: preview_1.createLink, getTarget: exports.getTarget }));
            return;
        }
        var value = (0, exports.formatMetadata)(c.identifier, file.customMeta[c.id], c);
        elements.push(React.createElement("div", { "data-length": value.toString().length, key: c.id, className: 'row__column ' + dataKey },
            React.createElement("span", null, value)));
    });
    return elements;
}, filesMemoize_1.memoizeSerializer);
var preview2D3DCell = function (file, baseUrl, token, convert, navigateTo) {
    var clickAction = function () {
        if (file.type === 'FOLDER' ||
            (file.preview && file.preview.status === 'PROCESSING'))
            return void 0;
        if (!file.preview || file.preview.status !== 'PROCESSED')
            return convert(file);
        navigateTo(baseUrl + "/preview/".concat(file.fileUuid, "/revision/").concat(file.uuid));
    };
    switch (file.type) {
        case 'DWG':
            return (React.createElement("div", { className: "row__column upload info icon narrow" },
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, file.preview && file.preview.status === 'PROCESSING'
                        ? (0, translation_1.getLocalization)('fileslist/listrow/dwg/pleaseWait')
                        : file.preview && file.preview.status === 'PROCESSED'
                            ? (0, translation_1.getLocalization)('fileslist/listrow/dwg/openViewer')
                            : (0, translation_1.getLocalization)('fileslist/listrow/dwg/export')) },
                    React.createElement(components_1.TableRowIcon, { icon: file.preview && file.preview.status === 'PROCESSING'
                            ? 'sok-icon-3d-orange'
                            : file.preview && file.preview.status === 'PROCESSED'
                                ? 'sok-icon-2d-green'
                                : 'sok-icon-2d-pink', onClick: clickAction }))));
        case 'IFC':
            return (React.createElement("div", { className: "row__column upload info icon narrow" },
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, file.preview && file.preview.status === 'PROCESSING'
                        ? (0, translation_1.getLocalization)('fileslist/listrow/bim/pleaseWait')
                        : file.preview && file.preview.status === 'PROCESSED'
                            ? (0, translation_1.getLocalization)('fileslist/listrow/bim/openViewer')
                            : file.preview && file.preview.status === 'FAILED'
                                ? (0, translation_1.getLocalization)('fileslist/listrow/bim/failed')
                                : (0, translation_1.getLocalization)('fileslist/listrow/bim/export')) },
                    React.createElement(components_1.TableRowIcon, { icon: file.preview && file.preview.status === 'PROCESSING'
                            ? 'sok-icon-3d-orange'
                            : file.preview && file.preview.status === 'PROCESSED'
                                ? 'sok-icon-3d-green'
                                : file.preview && file.preview.status === 'FAILED'
                                    ? 'sok-icon-3d-red'
                                    : 'sok-icon-3d-pink', onClick: clickAction }))));
        case 'PDF':
            return (React.createElement("div", { className: "row__column external_link info icon narrow" }, file.type === 'PDF' ? (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('fileslist/listrow/openToNotWindow')) },
                React.createElement("a", { target: '_blank', href: (0, preview_1.createLink)(file, baseUrl, true, token) },
                    React.createElement(components_1.TableRowIcon, { className: 'blue', icon: 'fa-external-link' })))) : null));
        default:
            return React.createElement("div", { className: "row__column upload info narrow" });
    }
};
exports.preview2D3DCell = preview2D3DCell;
exports.enhanceRow = (0, recompose_1.compose)((0, recompose_1.shouldUpdate)(function (nextProps, props) {
    var index = nextProps.index, data = nextProps.data;
    var oldData = props.data;
    var file = data.items[index];
    if (data.isMobile !== oldData.isMobile) {
        return true;
    }
    if (data.itemSelections[file.uuid] !== oldData.itemSelections[file.uuid]) {
        return true;
    }
    if (file.bookmarked !== oldData.items[index].bookmarked) {
        return true;
    }
    if (data.columns !== oldData.columns) {
        return true;
    }
    var oldFile = oldData.items[index];
    if (file.type !== 'FOLDER' &&
        file.preview &&
        oldFile.type !== 'FOLDER' &&
        oldFile.preview &&
        file.preview.status !== oldFile.preview.status) {
        return true;
    }
    if (props.style !== nextProps.style) {
        return true;
    }
    if (data.items[index] !== oldData.items[index]) {
        return true;
    }
    return false;
}));
exports.ListRow = (0, exports.enhanceRow)(React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var isMobile = data.isMobile, mode = data.mode, items = data.items, columns = data.columns, baseUrl = data.baseUrl, itemSelections = data.itemSelections, downloadFolder = data.downloadFolder, convert = data.convert, openNotificationsSideMenu = data.openNotificationsSideMenu, navigateTo = data.navigateTo, toggleItem = data.toggleItem, onBookmark = data.onBookmark, onUnBookmark = data.onUnBookmark, token = data.token, hideActions = data.hideActions, hideDownload = data.hideDownload, metaDataColumns = data.metaDataColumns;
    var file = items[index];
    var selected = itemSelections[file.uuid];
    var downloadLinkUrl = "".concat(__UPLOADSERVERURL__, "/files/").concat(file.uuid);
    var url = baseUrl.replace(/\/[^\/]*$/, '/' + file.parent);
    var fileIconClass;
    var fileIcon = FileIcon_1.iconMap[file.type];
    if (((data.perm || 0x00) & (file.feature || 0x00) & acl.SUBPROJECT_PERM) >
        0) {
        fileIcon = FileIcon_1.iconMap['SUBPROJECT'];
        var subprojectMeta = metaDataColumns.find(function (x) { return x.identifier === 'subproject-status-meta'; });
        if (subprojectMeta &&
            subprojectMeta.id !== undefined &&
            file.type === 'FOLDER') {
            var folderStatus_1 = file.customMeta[subprojectMeta.id];
            var metaValue = (subprojectMeta.options || []).find(function (x) { return x.value === folderStatus_1; });
            if (metaValue) {
                fileIconClass = "subproject-".concat(metaValue.name);
            }
        }
    }
    return (React.createElement("div", { className: className + ' ' + (file.type !== 'FOLDER' ? 'file' : ''), style: style },
        React.createElement("div", { className: "row__column first narrow icon" },
            React.createElement("div", { className: classNames('file-icon', fileIconClass) }, fileIcon)),
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, className: selected ? 'selected' : null, onClick: function (e) {
                    e.stopPropagation();
                    toggleItem(file);
                } })),
        !hideActions && (React.createElement("div", { className: "row__column narrow bookmarked icon" },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-bookmark', className: file.bookmarked ? 'bookmarked' : '', onClick: function (e) {
                    e.stopPropagation();
                    var id = file.type === 'FOLDER' ? file.id : file.file;
                    file.bookmarked ? onUnBookmark([id]) : onBookmark([id]);
                } }))),
        !hideDownload && (React.createElement("div", { className: 'row__column narrow download icon' }, file.type === 'FOLDER' ? (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/toolTip/downloadFolder')) },
            React.createElement(sok_ui_1.Icon, { className: 'sok-icon-download-cloud sok-icon-download-cloud-center', onClick: function () {
                    downloadFolder(file);
                } }))) : (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/toolTip/downloadFile')) },
            React.createElement("a", { href: downloadLinkUrl, target: "_blank" },
                React.createElement(sok_ui_1.Icon, { className: 'sok-icon-download-cloud sok-icon-download-cloud-center' })))))),
        !hideActions && (React.createElement("div", { className: 'row__column narrow notification icon' },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('fileslist/listrow/shownotifications')) },
                React.createElement(components_1.TableRowIcon, { icon: 'fa-bell', className: classNames(file.notifications &&
                        (file.notifications.email ||
                            file.notifications.pushnotifications) &&
                        'active'), onClick: function () { return openNotificationsSideMenu(file); } })))),
        !hideActions &&
            (file.type !== 'FOLDER' && file.version > 1 ? (React.createElement("div", { className: "row__column revision info narrow" },
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('fileslist/listrow/seeRevisions')) },
                    React.createElement(react_router_dom_1.Link, { to: baseUrl + "/revisions/".concat(file.fileUuid) },
                        React.createElement(components_1.TableRowIcon, { icon: 'icofont-history' }))))) : (React.createElement("div", { className: "row__column revision info narrow" }))),
        mode === 'SEARCH' ? (React.createElement("div", { className: "row__column go-to narrow" },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('fileslist/listrow/gotoFolder')) },
                React.createElement(react_router_dom_1.Link, { to: url, onClick: function (e) {
                        if (window.location.pathname === url) {
                            e.preventDefault();
                            window.location.reload();
                        }
                    } },
                    React.createElement(components_1.TableRowIcon, { icon: 'fa-angle-double-right' }))))) : null,
        (0, exports.preview2D3DCell)(file, baseUrl, token, convert, navigateTo),
        (0, exports.renderCustomMeta)(columns, file, baseUrl, isMobile, token)));
}, function (prevProps, nextProps) {
    if (nextProps.data !== prevProps.data) {
        return false;
    }
    return true;
}));
